// Shared by the in-app avatar and the notification icon drawn in the service worker.
const COLORS = ['#e17055', '#00b894', '#0984e3', '#6c5ce7', '#e84393', '#fdcb6e', '#00cec9', '#d35400'];

export function colorFor(id: string) {
  let h = 0;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return COLORS[h % COLORS.length];
}

export function initials(name: string) {
  const parts = name.replace(/^@/, '').trim().split(/[\s_]+/);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?';
}
